import { Button, Heading, Icon, IconButton, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";

import { FaArrowLeft, FaArrowRight, FaColumns, FaHistory, FaPlus, FaSync, FaUnlock } from "react-icons/fa";
import { GiWallet } from "react-icons/gi";
import { RiFilterOffFill } from "react-icons/ri";

export default function BillingHistory() {
    const [invs] = useState([
        {
            orgId: 2939,
            orgName: "John Bro",
            ownerName: 'John Bro',
            ownerEmail: "john@yopmail.com",
            subscriptionStatus: 'Active',
            currentPlan: 'Standard Plan',
            processStatus: "Active",
            blockReason: "-",
            invoiceStatus: 'null',
            invoiceId: 'Z-NULL',
            invoiceDate: '-',
            timeElapsedInvDate: '52 years ago',
            renewalDate: '-',
            timeElapsedRenewalDate: '53 years ago',
            orgLastUpdate: '26-May-22 12:57:11',
            orgStatus: 'Active',
            billedAmount: 0.00,
            creditPurchased: 0,
            creditAdded: 0,
            creditCarriedForward: 0,
            invoiceCredits: 0,
            statementLines: '0 Transactions',
            statementsCredit: 0,
            otherDocProcessed: 0,
            otherDocCredits: 0,
            totalCreditsUsed: 0,
            remainingCredits: 0
        },
        {
            orgId: 2939,
            orgName: "John Bro",
            ownerName: 'John Bro',
            ownerEmail: "john@yopmail.com",
            subscriptionStatus: 'Active',
            currentPlan: 'Standard Plan',
            processStatus: "Active",
            blockReason: "-",
            invoiceStatus: 'null',
            invoiceId: 'Z-NULL',
            invoiceDate: '-',
            timeElapsedInvDate: '52 years ago',
            renewalDate: '-',
            timeElapsedRenewalDate: '53 years ago',
            orgLastUpdate: '26-May-22 12:57:11',
            orgStatus: 'Active',
            billedAmount: 0.00,
            creditPurchased: 0,
            creditAdded: 0,
            creditCarriedForward: 0,
            invoiceCredits: 0,
            statementLines: '0 Transactions',
            statementsCredit: 0,
            otherDocProcessed: 0,
            otherDocCredits: 0,
            totalCreditsUsed: 0,
            remainingCredits: 0
        },        {
            orgId: 2939,
            orgName: "John Bro",
            ownerName: 'John Bro',
            ownerEmail: "john@yopmail.com",
            subscriptionStatus: 'Active',
            currentPlan: 'Standard Plan',
            processStatus: "Active",
            blockReason: "-",
            invoiceStatus: 'null',
            invoiceId: 'Z-NULL',
            invoiceDate: '-',
            timeElapsedInvDate: '52 years ago',
            renewalDate: '-',
            timeElapsedRenewalDate: '53 years ago',
            orgLastUpdate: '26-May-22 12:57:11',
            orgStatus: 'Active',
            billedAmount: 0.00,
            creditPurchased: 0,
            creditAdded: 0,
            creditCarriedForward: 0,
            invoiceCredits: 0,
            statementLines: '0 Transactions',
            statementsCredit: 0,
            otherDocProcessed: 0,
            otherDocCredits: 0,
            totalCreditsUsed: 0,
            remainingCredits: 0
        },
        {
            orgId: 2939,
            orgName: "John Bro",
            ownerName: 'John Bro',
            ownerEmail: "john@yopmail.com",
            subscriptionStatus: 'Active',
            currentPlan: 'Standard Plan',
            processStatus: "Active",
            blockReason: "-",
            invoiceStatus: 'null',
            invoiceId: 'Z-NULL',
            invoiceDate: '-',
            timeElapsedInvDate: '52 years ago',
            renewalDate: '-',
            timeElapsedRenewalDate: '53 years ago',
            orgLastUpdate: '26-May-22 12:57:11',
            orgStatus: 'Active',
            billedAmount: 0.00,
            creditPurchased: 0,
            creditAdded: 0,
            creditCarriedForward: 0,
            invoiceCredits: 0,
            statementLines: '0 Transactions',
            statementsCredit: 0,
            otherDocProcessed: 0,
            otherDocCredits: 0,
            totalCreditsUsed: 0,
            remainingCredits: 0
        },
        {
            orgId: 2939,
            orgName: "John Bro",
            ownerName: 'John Bro',
            ownerEmail: "john@yopmail.com",
            subscriptionStatus: 'Active',
            currentPlan: 'Standard Plan',
            processStatus: "Active",
            blockReason: "-",
            invoiceStatus: 'null',
            invoiceId: 'Z-NULL',
            invoiceDate: '-',
            timeElapsedInvDate: '52 years ago',
            renewalDate: '-',
            timeElapsedRenewalDate: '53 years ago',
            orgLastUpdate: '26-May-22 12:57:11',
            orgStatus: 'Active',
            billedAmount: 0.00,
            creditPurchased: 0,
            creditAdded: 0,
            creditCarriedForward: 0,
            invoiceCredits: 0,
            statementLines: '0 Transactions',
            statementsCredit: 0,
            otherDocProcessed: 0,
            otherDocCredits: 0,
            totalCreditsUsed: 0,
            remainingCredits: 0
        },
        {
            orgId: 2939,
            orgName: "John Bro",
            ownerName: 'John Bro',
            ownerEmail: "john@yopmail.com",
            subscriptionStatus: 'Active',
            currentPlan: 'Standard Plan',
            processStatus: "Active",
            blockReason: "-",
            invoiceStatus: 'null',
            invoiceId: 'Z-NULL',
            invoiceDate: '-',
            timeElapsedInvDate: '52 years ago',
            renewalDate: '-',
            timeElapsedRenewalDate: '53 years ago',
            orgLastUpdate: '26-May-22 12:57:11',
            orgStatus: 'Active',
            billedAmount: 0.00,
            creditPurchased: 0,
            creditAdded: 0,
            creditCarriedForward: 0,
            invoiceCredits: 0,
            statementLines: '0 Transactions',
            statementsCredit: 0,
            otherDocProcessed: 0,
            otherDocCredits: 0,
            totalCreditsUsed: 0,
            remainingCredits: 0
        },
        {
            orgId: 2939,
            orgName: "John Bro",
            ownerName: 'John Bro',
            ownerEmail: "john@yopmail.com",
            subscriptionStatus: 'Active',
            currentPlan: 'Standard Plan',
            processStatus: "Active",
            blockReason: "-",
            invoiceStatus: 'null',
            invoiceId: 'Z-NULL',
            invoiceDate: '-',
            timeElapsedInvDate: '52 years ago',
            renewalDate: '-',
            timeElapsedRenewalDate: '53 years ago',
            orgLastUpdate: '26-May-22 12:57:11',
            orgStatus: 'Active',
            billedAmount: 0.00,
            creditPurchased: 0,
            creditAdded: 0,
            creditCarriedForward: 0,
            invoiceCredits: 0,
            statementLines: '0 Transactions',
            statementsCredit: 0,
            otherDocProcessed: 0,
            otherDocCredits: 0,
            totalCreditsUsed: 0,
            remainingCredits: 0
        },
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                align={'center'}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={GiWallet}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Billing History</Heading>
                            <Text fontSize={'sm'}>Here you can view your billing information.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaSync />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Refresh
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<RiFilterOffFill />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Clear Filter
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaColumns />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Columns
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaHistory />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            History
                        </Button>
                    </Stack>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            // leftIcon={<FaHistory />}
                            color={'white'}
                            bg={'red.400'}
                            _hover={{ bg: 'red.500' }}
                            _active={{ bg: 'red.600' }}
                        >
                            Delete Organization
                        </Button>
                        <Button
                            size={'sm'}
                            // leftIcon={<FaHistory />}
                            color={'white'}
                            bg={'gray.400'}
                            _hover={{ bg: 'gray.500' }}
                            _active={{ bg: 'gray.600' }}
                        >
                            Block Organization
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaUnlock />}
                            color={'white'}
                            bg={'gray.400'}
                            _hover={{ bg: 'gray.500' }}
                            _active={{ bg: 'gray.600' }}
                        >
                            Unblock Organization
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaPlus />}
                            color={'white'}
                            bg={'green.400'}
                            _hover={{ bg: 'green.500' }}
                            _active={{ bg: 'green.600' }}
                        >
                            Add Credits
                        </Button>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'} zIndex={1}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    Org ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Organization Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Owner Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Owner Email
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Subscription Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Current Plan
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Process Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Block Reason
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Invoice Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Invoice ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Invoice Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Time Elapsed Inv Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Renewal Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Time Elapsed Renewal Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Org Last Update Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Org Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Billed Amount
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Credits Purchased
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Credits Added
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Credits Carried Forward
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Invoice Credits
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Statements Lines / Pages
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Other Doc Pages Processed
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Other Doc Credits
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Total Credits Used
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Remaining Credits
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Business Usage
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Delete Organization
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.map((inv, i) => (
                                    <Tr>
                                        <Td>{inv.orgId}</Td>
                                        <Td>{inv.orgName}</Td>
                                        <Td>{inv.ownerName}</Td>
                                        <Td>{inv.ownerEmail}</Td>
                                        <Td>{inv.subscriptionStatus}</Td>
                                        <Td>{inv.currentPlan}</Td>
                                        <Td>{inv.processStatus}</Td>
                                        <Td>{inv.blockReason}</Td>
                                        <Td>{inv.invoiceStatus}</Td>
                                        <Td>{inv.invoiceId}</Td>
                                        <Td>{inv.invoiceDate}</Td>
                                        <Td>{inv.timeElapsedInvDate}</Td>
                                        <Td>{inv.renewalDate}</Td>
                                        <Td>{inv.orgLastUpdate}</Td>
                                        <Td>{inv.orgStatus}</Td>
                                        <Td>{inv.billedAmount}</Td>
                                        <Td>{inv.creditPurchased}</Td>
                                        <Td>{inv.creditAdded}</Td>
                                        <Td>{inv.creditCarriedForward}</Td>
                                        <Td>{inv.invoiceCredits}</Td>
                                        <Td>{inv.statementLines}</Td>
                                        <Td>{inv.statementsCredit}</Td>
                                        <Td>{inv.otherDocProcessed}</Td>
                                        <Td>{inv.otherDocCredits}</Td>
                                        <Td>{inv.totalCreditsUsed}</Td>
                                        <Td>{inv.remainingCredits}</Td>
                                        <Td>
                                            <Button
                                                colorScheme={'primary'}
                                            >
                                                Usage
                                            </Button>
                                        </Td>
                                        <Td>
                                            <Button
                                                colorScheme={'red'}
                                            >
                                                Delete Org
                                            </Button>
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}